import type { SVGProps } from 'react';
const SvgTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Time_svg__a)">
      <path
        d="M8 5.734V8l2.832 2.832M1.656 8a6.344 6.344 0 1 0 12.688 0A6.344 6.344 0 0 0 1.656 8"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Time_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTime;
